import {
  CardElement,
  Elements,
  useElements,
  useStripe
} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { functions } from 'config/firebase'
import { EventEmitter } from 'events'
import * as React from 'react'
import './style.scss'

interface IProps {
  goToCongratulationsTab: () => void
  parentId: string
  parentName: string
  parentEmail: string
  upgradeUser: () => void
  fontSize: string
  checkoutEvent: EventEmitter
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  setDisabled: React.Dispatch<React.SetStateAction<boolean>>
  disabled: boolean
}

const CheckoutForm = ({
  parentId,
  parentName,
  parentEmail,
  upgradeUser,
  fontSize,
  checkoutEvent,
  setLoading,
  setDisabled,
  disabled
}: IProps) => {
  const stripe = useStripe()
  const elements = useElements()
  const resultContainer = document.getElementById('card-result')
  const [color, setColor] = React.useState('')
  const timer = React.useRef<any>()

  const handleSubmit = async () => {
    const card = elements?.getElement(CardElement)
    if (disabled) {
      return
    }
    setDisabled(true)

    if (card) {
      card.on('change', event => {
        setColor('')
        if (resultContainer) {
          resultContainer.textContent = ''
        }
      })
      timer.current = setTimeout(() => {
        setLoading(true)
      }, 100)

      try {
        const result = await stripe?.createPaymentMethod({
          type: 'card',
          card,
          billing_details: {
            name: parentName
          }
        })

        if (result) {
          if (result.error?.message && resultContainer) {
            resultContainer.textContent = result.error.message
            setDisabled(false)
            clearTimeout(timer.current)
            setLoading(false)
          } else {
            const customer = await addcustomer({
              uid: parentId,
              name: parentName,
              email: parentEmail,
              payment_method: result.paymentMethod?.id
            })

            if (customer && customer.data) {
              upgradeUser()
            } else {
              throw new Error()
            }
          }
        }
      } catch (e) {
        if (resultContainer) {
          resultContainer.textContent = 'Please use a valid credit card'
          setColor('#eb1c26')
        }
        setLoading(false)
        clearTimeout(timer.current)
        setDisabled(false)
      }
    } else {
      console.error('handleSubmit: card is not defined')
      setDisabled(false)
    }
  }

  const subscribeCheckoutEvent = () => {
    checkoutEvent.addListener('checkout', handleSubmit)
  }

  const unsubscribeCheckoutEvent = () => {
    checkoutEvent.removeListener('checkout', handleSubmit)
  }

  React.useEffect(
    () => () => {
      unsubscribeCheckoutEvent()
      clearTimeout(timer.current)
    },
    []
  )

  const addcustomer = functions.httpsCallable(
    'createCustomerFromPaymentDetails'
  )

  return (
    <div className="design-fixes form-height">
      <CardElement
        options={{
          hidePostalCode: true,
          style: {
            base: {
              fontFamily: 'Open Sans',
              fontSize,
              lineHeight: '1.62',
              fontWeight: '600',
              color
            }
          }
        }}
        onReady={subscribeCheckoutEvent}
      />
      <div id="card-result" />
    </div>
  )
}

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLIC_KEY ||
    'pk_live_CuywirsMWEVYU9W90ZdPebee00dTzCg38Y'
)

export const PaymentSaveCardComponent = ({
  parentId,
  goToCongratulationsTab,
  parentName,
  parentEmail,
  upgradeUser,
  fontSize,
  checkoutEvent,
  setLoading,
  setDisabled,
  disabled
}: IProps) => (
  <Elements
    stripe={stripePromise}
    options={{
      fonts: [
        {
          cssSrc:
            'https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap'
        }
      ]
    }}
  >
    <CheckoutForm
      parentId={parentId}
      goToCongratulationsTab={goToCongratulationsTab}
      parentName={parentName}
      parentEmail={parentEmail}
      upgradeUser={upgradeUser}
      fontSize={fontSize}
      checkoutEvent={checkoutEvent}
      setLoading={setLoading}
      setDisabled={setDisabled}
      disabled={disabled}
    />
  </Elements>
)



// WEBPACK FOOTER //
// ./src/components/PaymentSaveCardComponent/index.tsx